

export function BridgerANSI(props, selectedStandard) {

    const { result, data, } = props

    const inputs = data?.repetitivelyPulsed ?? data?.cw ?? data?.singlePulse ?? data?.FO_cw ?? data?.FO_singlePulse ?? data?.FO_repetitivelyPulsed

    const getAE = (AE, unit) => {
        if (AE.includes("J") || AE.includes("W")) {
            return AE
        }
        else if (unit === "W") {
            return AE + "W/m²"
        }
        else if (unit === "J") {
            return AE + "J/m²"
        }
    }
    const MPE = result?.mpe?.result?.mpeStandard?.pretty || result?.MPE?.single?.result?.mpeStandard?.pretty

    const x = {
        laserOperation: data?.laserOperation.toLowerCase(),
        sourceType: data?.sourceType,
        standard: selectedStandard,
        wavelength: `${inputs.wavelength.num} ${inputs.wavelength.unit !== false ? inputs.wavelength.unit : " "}m`,
        ...(inputs.time) ? {
            time: `${inputs?.time?.num}${inputs.time.unit && inputs?.time?.unit !== false ? inputs?.time?.unit : " "}s`,
        } : {},
        ...(inputs.duration) ?
        {
            pulseDuration: `${inputs?.duration?.num} ${inputs?.duration?.unit !== false ? inputs?.duration?.unit : " "}s`
        }
        :
        {
            pulseDuration: `${inputs?.pulseDuration?.num} ${inputs?.pulseDuration?.unit !== false ? inputs?.pulseDuration?.unit : " "}s`
        },

        ...(inputs.power ? {
            power: `${inputs.power.num} ${inputs.power.unit !== false ? inputs.power.unit : " "}W`
        } 
        : inputs.peakPower ? {
            peakPower: `${inputs.peakPower.num} ${inputs.peakPower.unit !== false ? inputs.peakPower.unit : " "}W`
        }
        : inputs.averagePower ? {
            averagePower: `${inputs.averagePower.num} ${inputs.averagePower.unit !== false ? inputs.averagePower.unit : " "}W`
        } : {
            energy: `${inputs.energy.num} ${inputs.energy.unit !== false ? inputs.energy.unit : " "}J`
        }),


        ...(data.extendedSettings ? {
            apparentSourceSize: `${data.extendedSettings?.apparentSourceSize?.num} ${data.extendedSettings?.apparentSourceSize?.unit !== false ? data.extendedSettings?.apparentSourceSize?.unit : " "}m`
        } : inputs?.diameter ? 
        {
            diameter: `${inputs?.diameter?.num} ${inputs?.diameter?.unit !== false ? inputs?.diameter?.unit : " "}m`
        } : inputs?.numerical_aperture ? 
        {
            numerical_aperture: `${inputs?.numerical_aperture?.num} ${inputs?.numerical_aperture?.unit && inputs?.numerical_aperture?.unit !== false ? inputs?.numerical_aperture?.unit : " "}`
        } 
        :
        {
            beamDiameter: `${inputs?.beamDiameter?.num} ${inputs?.beamDiameter?.unit !== false && inputs?.beamDiameter?.unit ? inputs?.beamDiameter?.unit : " "}m`,

        }),
        ...(inputs.beamDivergence ? {
            beamDivergence: `${inputs?.beamDivergence?.num} ${inputs?.beamDivergence?.unit !== false ? inputs?.beamDivergence?.unit : " "}m`,
        }: {
            beamDivergence: result?.beamDivergence,
        }),

        ...(inputs?.pulseFrequency && {
            pulseFrequency: `${inputs?.pulseFrequency?.num} ${inputs?.pulseFrequency?.unit !== false ? inputs?.pulseFrequency?.unit : " "}Hz`
        }),
        distance: `${inputs.distance.num} ${inputs.distance.unit !== false ? inputs.distance.unit : " "}m`,
        spot_size: result?.outputBeamDiameter.pretty,
        eye_LA: result.limitAperture.eye + 'mm',
        skin_LA: result.limitAperture.skin + 'mm',
        applicable_eye: result?.applicableBeamArea?.prettiest,
        applicable_skin: result?.skinApplicableBeamArea?.prettiest,
        timebase: '5s',


        mpe: {
            eye: {
                ...(result.laserOperation.includes('repetitivelyPulsed')
                    ? {
                        mpe: {
                            single: {
                                mpe: result?.MPE?.single?.result?.mpeStandard?.pretty,
                                excess: result?.safetyRatio?.single_pretty || result.safetyratio.joulesPretty.pretty,
                                ae_applicable: result?.MPE?.single?.result?.mpeStandard?.unit?.includes("J") ? getAE(result?.AE?.joulesPerSqmPretty?.eng ?? result?.AE?.joulesPerSqmPretty, "J") : getAE(result?.AE?.wattsPerSqmPretty?.eng ?? result?.AE?.wattsPerSqmPretty, "W"),
                                ae_actual: result?.MPE?.single?.result?.mpeStandard?.unit?.includes("J") ? getAE(result?.AE?.actual_joulesPerSqmPretty?.eng ?? result?.AE?.actual_joulesPerSqmPretty, "J") : getAE(result?.AE?.actual_wattsPerSqmPretty?.eng ?? result?.AE?.actual_wattsPerSqmPretty, "W"),
                            },
                            pulse_train: {
                                mpe: result?.MPE?.pulseTrain?.pretty,
                                excess: result?.safetyRatio?.train_pretty || result.safetyratio.averagePretty.pretty,
                                ae_applicable: result?.MPE?.pulseTrain?.unit?.includes("J") ? getAE(result?.AE?.joulesPerSqmPretty?.eng ?? result?.AE?.joulesPerSqmPretty, "J") : getAE(result?.AE?.wattsPerSqmPretty?.eng ?? result?.AE?.wattsPerSqmPretty, "W"),
                                ae_actual: result?.MPE?.pulseTrain?.unit?.includes("J") ? getAE(result?.AE?.actual_joulesPerSqmPretty?.eng ?? result?.AE?.actual_joulesPerSqmPretty, "J") : getAE(result?.AE?.actual_wattsPerSqmPretty?.eng ?? result?.AE?.actual_wattsPerSqmPretty, "W"),
                            },
                            average: {
                                mpe: result?.MPE?.average?.pretty,
                                excess: result?.safetyRatio?.average_pretty || result.safetyratio.pulseTrainPretty.pretty,
                                ae_applicable: result?.MPE?.average?.unit?.includes("J") ? getAE(result?.AE?.joulesPerSqmPretty?.eng ?? result?.AE?.joulesPerSqmPretty, "J") : getAE(result?.AE?.wattsPerSqmPretty?.eng ?? result?.AE?.wattsPerSqmPretty, "W"),
                                ae_actual: result?.MPE?.average?.unit?.includes("J") ? getAE(result?.AE?.actual_joulesPerSqmPretty?.eng ?? result?.AE?.actual_joulesPerSqmPretty, "J") : getAE(result?.AE?.actual_wattsPerSqmPretty?.eng ?? result?.AE?.actual_wattsPerSqmPretty, "W"),
                            }
                        },
                        ae_applicable: MPE?.includes("J") ? getAE(result?.AE?.joulesPerSqmPretty?.eng ?? result?.AE?.joulesPerSqmPretty, "J") : getAE(result?.AE?.wattsPerSqmPretty?.eng ?? result?.AE?.wattsPerSqmPretty, "W"),
                        ae_actual: MPE?.includes("J") ? getAE(result?.AE?.actual_joulesPerSqmPretty?.eng ?? result?.AE?.actual_joulesPerSqmPretty, "J") : getAE(result?.AE?.actual_wattsPerSqmPretty?.eng ?? result?.AE?.actual_wattsPerSqmPretty, "W"),
                        excess: result?.safetyRatio?.num,
                        mostRestrictive: getMostRestrictiveKey("eye", result),
                    }
                    : {
                        mpe: MPE || 1,
                        ae_applicable: MPE?.includes("J") ? getAE(result?.AE?.joulesPerSqmPretty?.eng ?? result?.AE?.joulesPerSqmPretty, "J") : getAE(result?.AE?.wattsPerSqmPretty?.eng ?? result?.AE?.wattsPerSqmPretty, "W"),
                        ae_actual: MPE?.includes("J") ? getAE(result?.AE?.actual_joulesPerSqmPretty?.eng ?? result?.AE?.actual_joulesPerSqmPretty, "J") : getAE(result?.AE?.actual_wattsPerSqmPretty?.eng ?? result?.AE?.actual_wattsPerSqmPretty, "W"),
                        excess: result?.safetyRatio?.pretty

                    }
                )
            },
            skin: {
                ...(result.laserOperation.includes('repetitivelyPulsed')
                    ? {
                        mpe: {
                            single: {
                                mpe: result?.skinMPE?.single?.result.mpeStandard?.pretty,
                                excess: result?.skinSafetyRatio?.single_pretty,
                                ae_applicable: result?.skinMPE?.single?.result?.mpeStandard?.unit?.includes("J") ? getAE(result?.skinAE?.joulesPerSqmPretty?.eng ?? result?.skinAE?.joulesPerSqmPretty, "J") : getAE(result?.skinAE?.wattsPerSqmPretty?.eng ?? result?.skinAE?.wattsPerSqmPretty, "W"),
                                ae_actual: result?.skinMPE?.single?.result?.mpeStandard?.unit?.includes("J") ? getAE(result?.skinAE?.actual_joulesPerSqmPretty?.eng ?? result?.skinAE?.actual_joulesPerSqmPretty, "J") : getAE(result?.skinAE?.actual_wattsPerSqmPretty?.eng ?? result?.skinAE?.actual_wattsPerSqmPretty, "W"),
                            },
                            pulse_train: {
                                mpe: result?.skinMPE?.pulseTrain?.pretty,
                                excess: result?.skinSafetyRatio?.train_pretty,
                                ae_applicable: result?.skinMPE?.pulseTrain?.unit?.includes("J") ? getAE(result?.skinAE?.joulesPerSqmPretty?.eng ?? result?.skinAE?.joulesPerSqmPretty, "J") : getAE(result?.skinAE?.wattsPerSqmPretty?.eng ?? result?.skinAE?.wattsPerSqmPretty, "W"),
                                ae_actual: result?.skinMPE?.pulseTrain?.unit?.includes("J") ? getAE(result?.skinAE?.actual_joulesPerSqmPretty?.eng ?? result?.skinAE?.actual_joulesPerSqmPretty, "J") : getAE(result?.skinAE?.actual_wattsPerSqmPretty?.eng ?? result?.skinAE?.actual_wattsPerSqmPretty, "W"),
                            },
                            average: {
                                mpe: result?.skinMPE?.average?.pretty,
                                excess: result?.skinSafetyRatio?.average_pretty,
                                ae_applicable: result?.skinMPE?.average?.unit?.includes("J") ? getAE(result?.skinAE?.joulesPerSqmPretty?.eng ?? result?.skinAE?.joulesPerSqmPretty, "J") : getAE(result?.skinAE?.wattsPerSqmPretty?.eng ?? result?.skinAE?.wattsPerSqmPretty, "W"),
                                ae_actual: result?.skinMPE?.average?.unit?.includes("J") ? getAE(result?.skinAE?.actual_joulesPerSqmPretty?.eng ?? result?.skinAE?.actual_joulesPerSqmPretty, "J") : getAE(result?.skinAE?.actual_wattsPerSqmPretty?.eng ?? result?.skinAE?.actual_wattsPerSqmPretty, "W"),
                            }
                        },
                        ae_applicable: MPE?.includes("J") ? getAE(result?.skinAE?.joulesPerSqmPretty?.eng ?? result?.skinAE?.joulesPerSqmPretty, "J") : getAE(result?.skinAE?.wattsPerSqmPretty?.eng ?? result?.skinAE?.wattsPerSqmPretty, "W"),
                        ae_actual: MPE?.includes("J") ? getAE(result?.skinAE?.actual_joulesPerSqmPretty?.eng ?? result?.skinAE?.actual_joulesPerSqmPretty, "J") : getAE(result?.skinAE?.actual_wattsPerSqmPretty?.eng ?? result?.skinAE?.actual_wattsPerSqmPretty, "W"),
                        excess: result?.skinSafetyRatio?.num,
                        mostRestrictive: getMostRestrictiveKey("skin", result),
                    }
                    : {
                        mpe: result.skinMPE.result.mpeStandard.pretty,
                        ae_applicable: result?.skinMPE?.mpeStandard?.unit.includes("J") ? getAE(result?.skinAE?.joulesPerSqmPretty?.eng ?? result?.skinAE?.joulesPerSqmPretty, "J") : getAE(result?.skinAE?.wattsPerSqmPretty?.eng ?? result?.skinAE?.wattsPerSqmPretty, "W"),
                        ae_actual: result?.skinMPE?.mpeStandard?.unit.includes("J") ? getAE(result?.skinAE?.actual_joulesPerSqmPretty?.eng ?? result?.skinAE?.actual_joulesPerSqmPretty, "J") : getAE(result?.skinAE?.actual_wattsPerSqmPretty?.eng ?? result?.skinAE?.actual_wattsPerSqmPretty, "W"),
                        excess: result?.skinSafetyRatio?.pretty
                    }
                )
            }
        },

        nohd: (result?.NOHD?.eng ?? result?.NOHD ?? result?.nohd.eng)?.includes("m") ? result?.NOHD?.eng || result?.NOHD || result?.nohd.eng : `${result?.NOHD?.eng || result?.NOHD || result?.nohd.eng}m`,
        enohd: (() => {
            const val =
                result?.ENOHD?.pretty ??
                result?.ENOHD ??
                result?.XNOHD?.pretty ??
                result?.xnohd?.pretty;
            return val ? (val.includes("m") ? val : `${val}m`) : 'N/A';
        })(),
        ael: {
            condition1: {
                classes: [
                    {
                        name: 'Class 1',
                        ael: result.ansiAEL.condition1.class1.AEL.single.aelStandard?.pretty || 'N/A',
                        pf: 'Fail',
                        excess: result.ansiAEL.condition1.class1.EHV.pretty || 'N/A',
                        ...(result.laserOperation.includes('repetitively')) && {
                            ael_spTrain: result.ansiAEL.condition1.class1.AEL.pulseTrain?.pretty || 'N/A',
                            ael_SPT: result.ansiAEL.condition1.class1.AEL.SPT?.pretty || 'N/A',
                            ael_T: result.ansiAEL.condition1.class1.AEL.T.aelStandard?.pretty || 'N/A',
                            mostRestrictive: getMostRestrictiveAEL(result.ansiAEL.condition1.class1.AEL, "class1", result.ansiAEL.condition1.details.collectedEmission.joules)
                        }
                    },
                    {
                        name: 'Class 2',
                        ael: result.ansiAEL.condition1.class2.AEL.single.aelStandard?.pretty || 'N/A',
                        pf: 'Fail',
                        excess: result.ansiAEL.condition1.class2.EHV.pretty || 'N/A',
                        ...(result.laserOperation.includes('repetitively')) && {
                            ael_spTrain: result.ansiAEL.condition1.class2.AEL.pulseTrain?.pretty || 'N/A',
                            ael_SPT: result.ansiAEL.condition1.class2.AEL.SPT?.pretty || 'N/A',
                            ael_T: result.ansiAEL.condition1.class1.AEL.T.aelStandard?.pretty || 'N/A',
                            mostRestrictive: getMostRestrictiveAEL(result.ansiAEL.condition1.class2.AEL, "class2", result.ansiAEL.condition1.details.collectedEmission.joules)
                        }
                    },
                    {
                        name: 'Class 3R',
                        ael: result.ansiAEL.condition1.class3r.AEL.single.aelStandard?.pretty || 'N/A',
                        pf: 'Fail',
                        excess: result.ansiAEL.condition1.class3r.EHV.pretty || 'N/A',
                        ...(result.laserOperation.includes('repetitively')) && {
                            ael_spTrain: result.ansiAEL.condition1.class3r.AEL.pulseTrain?.pretty || 'N/A',
                            ael_SPT: result.ansiAEL.condition1.class3r.AEL.SPT?.pretty || 'N/A',
                            ael_T: result.ansiAEL.condition1.class1.AEL.T.aelStandard?.pretty || 'N/A',
                            mostRestrictive: getMostRestrictiveAEL(result.ansiAEL.condition1.class3r.AEL, "class3r", result.ansiAEL.condition1.details.collectedEmission.joules)
                        }
                    },
                    {
                        name: 'Class 3B',
                        ael: result.ansiAEL.condition1.class3b.AEL.single.aelStandard?.pretty || 'N/A',
                        pf: 'Fail',
                        excess: result.ansiAEL.condition1.class3b.EHV.pretty || 'N/A',
                        ...(result.laserOperation.includes('repetitively')) && {
                            ael_spTrain: result.ansiAEL.condition1.class3b.AEL.pulseTrain?.pretty || 'N/A',
                            ael_SPT: result.ansiAEL.condition1.class3b.AEL.SPT?.pretty || 'N/A',
                            ael_T: result.ansiAEL.condition1.class1.AEL.T.aelStandard?.pretty || 'N/A',
                            mostRestrictive: getMostRestrictiveAEL(result.ansiAEL.condition1.class3b.AEL, "class3b", result.ansiAEL.condition1.details.collectedEmission.joules)
                        }
                    },
                    {
                        name: 'Collected Emission',
                        ael: `${result.ansiAEL.condition1.details.collectedEmission.joulesPretty} | ${result.ansiAEL.condition1.details.collectedEmission.wattsPretty}`
                    }
                ],
                misc: [
                    {
                        name: 'Aperture Stop',
                        value: result.ansiAEL.condition1.details.measurementAperture.apertureDiameter
                    },
                    {
                        name: 'Aperture Distance',
                        value: result.ansiAEL.condition1.details.measurementAperture.measurementDistance
                    },
                    {
                        name: 'Angular Subtense',
                        value: result?.laserClass?.condition1?.angularSubtense || 'N/A'
                    },
                    {
                        name: 'Acceptance Angle',
                        value: result?.laserClass?.condition1?.acceptanceAngle || 'N/A'
                    }
                ]
            },
            ...(result.laserOperation.includes('FO') && {
                condition2: {
                    classes: [
                        {
                            name: 'Class 1',
                            ael: result.ansiAEL.condition2.class1.AEL.single.aelStandard?.pretty || 'N/A',
                            pf: 'Fail',
                            excess: result.ansiAEL.condition2.class1.EHV.pretty || 'N/A',
                            ...(result.laserOperation.includes('repetitively')) && {
                                ael_spTrain: result.laserClass.condition2.AEL_standard.pulseTrain.c1?.pretty || 'N/A',
                                ael_SPT: result.laserClass.condition2.AEL_standard.AELSPT.c1?.pretty || 'N/A',
                                ael_T: result.laserClass.condition2.AEL_standard.Average.c1.standard?.pretty || 'N/A',
                                mostRestrictive: getMostRestrictiveAEL(result.laserClass.condition2.AEL_standard, "class1", result.laserClass.condition2.collectedEmissionJoules.joules)
                            }
                        },
                        {
                            name: 'Class 2',
                            ael: result.ansiAEL.condition2.class2.AEL.single.aelStandard?.pretty || 'N/A',
                            pf: 'Fail',
                            excess: result.ansiAEL.condition2.class2.EHV.pretty || 'N/A',
                            ...(result.laserOperation.includes('repetitively')) && {
                                ael_spTrain: result.laserClass.condition2.AEL_standard?.pulseTrain?.c2?.pretty || 'N/A',
                                ael_SPT: result.laserClass.condition2.AEL_standard?.AELSPT?.c2?.pretty || 'N/A',
                                ael_T: result.laserClass.condition2.AEL_standard?.Average?.c2?.standard?.pretty || 'N/A',
                                mostRestrictive: getMostRestrictiveAEL(result.laserClass.condition2.AEL_standard, "class2", result.laserClass.condition2.collectedEmissionJoules.joules)
                            }
                        },
                        {
                            name: 'Class 3R',
                            ael: result.ansiAEL.condition2.class3r.AEL.single.aelStandard?.pretty || 'N/A',
                            pf: 'Fail',
                            excess: result.ansiAEL.condition2.class3r.EHV.pretty || 'N/A',
                            ...(result.laserOperation.includes('repetitively')) && {
                                ael_spTrain: result.laserClass.condition2.AEL_standard.pulseTrain.c3r?.pretty || 'N/A',
                                ael_SPT: result.laserClass.condition2.AEL_standard.AELSPT.c3r?.pretty || 'N/A',
                                ael_T: result.laserClass.condition2.AEL_standard.Average.c3r.standard?.pretty || 'N/A',
                                mostRestrictive: getMostRestrictiveAEL(result.laserClass.condition2.AEL_standard, "class3r", result.laserClass.condition2.collectedEmissionJoules.joules)
                            }
                        },
                        {
                            name: 'Class 3B',
                            ael: result.ansiAEL.condition2.class3b.EHV.pretty || 'N/A',
                            pf: 'Fail',
                            excess: result.laserClass.condition2.AEL_standard.Excess.c3bexcess?.pretty || 'N/A',
                            ...(result.laserOperation.includes('repetitively')) && {
                                ael_spTrain: result.laserClass.condition2.AEL_standard.pulseTrain.c3b?.pretty || 'N/A',
                                ael_SPT: result.laserClass.condition2.AEL_standard.AELSPT.c3b?.pretty || 'N/A',
                                ael_T: result.laserClass.condition2.AEL_standard.Average.c3b.standard?.pretty || 'N/A',
                                mostRestrictive: getMostRestrictiveAEL(result.laserClass.condition2.AEL_standard, "class3b", result.laserClass.condition2.collectedEmissionJoules.joules)
                            }
                        },
                        {
                            name: 'Collected Emission',
                            ael: `${result.laserClass.condition2.collectedEmissionJoules.joulesPretty} | ${result.laserClass.condition2.collectedEmissionWatts.wattsPretty}`
                        }
                    ],
                    misc: [
                        {
                            name: 'Aperture Stop',
                            value: result.laserClass.condition2.apertureStop
                        },
                        {
                            name: 'Aperture Distance',
                            value: result.laserClass.condition2.apertureDistance
                        },
                        {
                            name: 'Angular Subtense',
                            value: result.laserClass.condition2.angularSubtense || 'N/A'
                        },
                        {
                            name: 'Acceptance Angle',
                            value: result.laserClass.condition2.acceptanceAngle || 'N/A'
                        }
                    ]
                },
            }),
            condition3: {
                classes: [
                    {
                        name: 'Class 1',
                        ael: result.ansiAEL.condition2.class1.AEL.single.aelStandard?.pretty || 'N/A',
                        pf: 'Fail',
                        excess: result.ansiAEL.condition2.class1.EHV.pretty || 'N/A',
                        ...(result.laserOperation.includes('repetitively')) && {
                            ael_spTrain: result.ansiAEL.condition2.class1.AEL.pulseTrain?.pretty || 'N/A',
                            ael_SPT: result.ansiAEL.condition2.class1.AEL.SPT?.pretty || 'N/A',
                            ael_T: result.ansiAEL.condition2.class1.AEL.T.aelStandard?.pretty || 'N/A',
                            mostRestrictive: getMostRestrictiveAEL(result.ansiAEL.condition2.class1.AEL, "class1", result.ansiAEL.condition2.details.collectedEmission.joules)
                        }
                    },
                    {
                        name: 'Class 2',
                        ael: result.ansiAEL.condition2.class2.AEL.single.aelStandard?.pretty || 'N/A',
                        pf: 'Fail',
                        excess: result.ansiAEL.condition2.class2.EHV.pretty || 'N/A',
                        ...(result.laserOperation.includes('repetitively')) && {
                            ael_spTrain: result.ansiAEL.condition2.class2.AEL.pulseTrain?.pretty || 'N/A',
                            ael_SPT: result.ansiAEL.condition2.class2.AEL.SPT?.pretty || 'N/A',
                            ael_T: result.ansiAEL.condition2.class2.AEL.T.aelStandard?.pretty || 'N/A',
                            mostRestrictive: getMostRestrictiveAEL(result.ansiAEL.condition2.class2.AEL, "class2", result.ansiAEL.condition2.details.collectedEmission.joules)
                        }
                    },
                    {
                        name: 'Class 3R',
                        ael: result.ansiAEL.condition2.class3r.AEL.single.aelStandard?.pretty || 'N/A',
                        pf: 'Fail',
                        excess: result.ansiAEL.condition2.class3r.EHV.pretty || 'N/A',
                        ...(result.laserOperation.includes('repetitively')) && {
                            ael_spTrain: result.ansiAEL.condition2.class3r.AEL.pulseTrain?.pretty || 'N/A',
                            ael_SPT: result.ansiAEL.condition2.class3r.AEL.SPT?.pretty || 'N/A',
                            ael_T: result.ansiAEL.condition2.class3r.AEL.T.aelStandard?.pretty || 'N/A',
                            mostRestrictive: getMostRestrictiveAEL(result.ansiAEL.condition2.class3r.AEL, "class3r", result.ansiAEL.condition2.details.collectedEmission.joules)
                        }
                    },
                    {
                        name: 'Class 3B',
                        ael: result.ansiAEL.condition2.class3b.AEL.single.aelStandard?.pretty || 'N/A',
                        pf: 'Fail',
                        excess: result.ansiAEL.condition2.class3b.EHV.pretty || 'N/A',
                        ...(result.laserOperation.includes('repetitively')) && {
                            ael_spTrain: result.ansiAEL.condition2.class3b.AEL.pulseTrain?.pretty || 'N/A',
                            ael_SPT: result.ansiAEL.condition2.class3b.AEL.SPT?.pretty || 'N/A',
                            ael_T: result.ansiAEL.condition2.class3b.AEL.T.aelStandard?.pretty || 'N/A',
                            mostRestrictive: getMostRestrictiveAEL(result.ansiAEL.condition2.class3b.AEL, "class3b", result.ansiAEL.condition2.details.collectedEmission.joules)
                        }
                    },
                    {
                        name: 'Collected Emission',
                        ael: `${result.ansiAEL.condition2.details.collectedEmission.joulesPretty} | ${result.ansiAEL.condition2.details.collectedEmission.wattsPretty}`
                    }
                ],
                misc: [
                    {
                        name: 'Aperture Stop',
                        value: result.ansiAEL.condition2.details.measurementAperture.apertureDiameter
                    },
                    {
                        name: 'Aperture Distance',
                        value: result.ansiAEL.condition2.details.measurementAperture.apertureDiameter
                    },
                    {
                        name: 'Angular Subtense',
                        value: result?.laserClass?.condition3?.angularSubtense || 'N/A'
                    },
                    {
                        name: 'Acceptance Angle',
                        value: result?.laserClass?.condition3?.acceptanceAngle || 'N/A'
                    }
                ]
            }
        },

        eyewear: [
            {
                config: 'Results at 200m',
                nominal_od: result.NominalOD.OD,
                rb_number: result.RBNumber,
                lb_glass: result.Glass,
                lb_plastic: result.Plastic,
                lb_glass_average: result.Glass_average,
                lb_plastic_average: result.Plastic_average,

            },
            {
                config: 'Results at 0.1m',
                nominal_od: result.NominalOD_distance.OD,
                rb_number: result.RBNumber_distance,
                lb_glass: result.Glass_Distance,
                lb_plastic: result.Plastic_Distance,
                lb_glass_average: result.GlassAverage_Distance,
                lb_plastic_average: result.PlasticAverage_Distance
                ,
            }
        ],

        verdict: result.verdict,

        correctionFactors: Array.isArray(result.correctionFactors)
            ? result.correctionFactors
            : Object.entries(result.correctionFactors || {}).map(([key, value]) => ({
                name: key,
                val: value.num,
                pretty: value.pretty
            })),

        spectrum: result.spectrum
    }

    return x
}

function getMostRestrictiveKey(type, result) {
    const source =
        type === 'eye'
            ? result?.MPE
            : result?.skinMPE;

    if (!source) return null;

    const values = {
        single: source?.single?.result?.mpeStandard?.num,
        pulse_train: source?.pulseTrain?.num || source?.PulseTrain?.mpeStandard?.num,
        average: source?.average?.num || source?.MPEAverage?.mpeStandard?.num
    };

    // Filter out undefined/null before finding min
    const filtered = Object.entries(values).filter(([_, v]) => v != null);

    if (filtered.length === 0) return null;

    const minVal = Math.min(...filtered.map(([_, v]) => v));

    // Return the key with the smallest value
    const mostRestrictive = filtered.find(([_, v]) => v === minVal)?.[0];
    return mostRestrictive || null;
}

function getMostRestrictiveAEL({ single, pulseTrain, SPT, }, cls, collectedEmission) {

    const values = {
        ael: single.aelStandard?.num,
        ael_spTrain: pulseTrain?.num,
        ael_SPT: SPT?.num,

    };

    // Filter out invalid (NaN) values
    const filtered = Object.entries(values).filter(([_, v]) => !isNaN(v));

    if (filtered.length === 0) return null;

    // Find smallest value
    const minVal = Math.min(...filtered.map(([_, v]) => v));



    // Get the key that matched the min
    const mostRestrictive = filtered.find(([_, v]) => v === minVal);

    const status = collectedEmission <= mostRestrictive[1] ? 'Pass' : 'Fail'

    return mostRestrictive
        ? { key: mostRestrictive[0], value: mostRestrictive[1], status: status }
        : null;
}

